import { api } from "@/lib/api";

export const trackLeadIntent = async ({ premiumLead, eventType, listing, metadata = {} }) => {
  const canSendAnonymousIntent = eventType === "whatsapp_enquire_click";
  if (!canSendAnonymousIntent && !premiumLead?.email && !premiumLead?.phone && !premiumLead?.whatsapp) return;
  try {
    await api.post("/lead-intent", {
      event_type: eventType,
      email: premiumLead.email,
      phone: premiumLead.phone || premiumLead.whatsapp,
      name: premiumLead.name,
      listing_id: listing?.id,
      listing_title: listing?.title,
      metadata: {
        district: listing?.district,
        is_star_buy: Number(listing?.value_gap_percentage || 0) > 5,
        listing_title: listing?.title,
        ...metadata,
      },
    });
  } catch {
    // Intent telemetry should never block UI flows.
  }
};